import axios from "axios";
import { getData } from "../../utils/util";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL
});

instance.interceptors.request.use(function requestSuccess(config) {
  if (getData("adminData")) {
    config.headers["authorization"] = `Bearer ${
      getData("adminData").authToken
      }`;
  }
  config.headers["Content-Type"] = "application/json";

  return config;
});

instance.interceptors.response.use(
  function responseSuccess(config) {
    return config;
  },
  function responseError(error) {
    // if(error.response.statusCode === 401){
    //     rootReducer.p
    // }

    return Promise.reject(error);
  }
);

export default instance;



// WEBPACK FOOTER //
// ./src/config/axios/index.js